
// import { Toast } from 'vant'

import LoadingComponent from 'vue-loading-overlay'
import MmpSpinner from '@/components/_common/mmp-loaging/Spinner'

const MmpLoading = {
  install (Vue, options) {
    var loadingStore = window.vue.getStore('loading')

    Vue.mmpLoading = Vue.prototype.$mmpLoading = {
      show (props = {}, slots = {}) {
        // console.log('[loadingStore.state.loadingCnt :', loadingStore.state.loadingCnt)
        if (loadingStore.state.loadingCnt < 1) {
          // document.body.classList.add('overflow')
          const forceProps = {
            // Optional parameters
            programmatic: true,
            container: null,
            canCancel: false,
            color: '#3498db',
            loader: 'spinner',
            width: 120,
            height: 120,
            opacity: 0.9
          }

          const propsData = Object.assign({}, forceProps)

          var instance = new (Vue.extend(LoadingComponent))({
            el: document.createElement('div'),
            propsData,
            components: {
              Spinner: MmpSpinner
            }
          })

          // var instance = Vue.$loading.show()

          loadingStore.commit('SET_INSTANCE', instance)
        }
        loadingStore.commit('INCREMENT')
      },
      hide () {
        loadingStore.commit('DECREMENT')
        if (loadingStore.state.loadingCnt < 1 && loadingStore.state.instance) {
          if (!Vue.popup.isModalActive()) {
            document.body.classList.remove('overflow')
          }

          loadingStore.state.instance.hide()
          loadingStore.commit('SET_INSTANCE')
        }
      },
      isLoading () {
        let isLoaging = loadingStore.state.loadingCnt < 1 && loadingStore.state.instance
        return isLoaging
      }
    }
  }
}

export default MmpLoading



// WEBPACK FOOTER //
// ./src/plugins/_common/MmpLoading.js